import { alpha, styled } from '@mui/material';
import Box from '@mui/material/Box';
// ? Material Ui
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
// ? Next js
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { API } from '_helpers';

const Item = styled(Card)(({ theme }) => ({
  '&:hover': {
    boxShadow: '0 15px 25px 0 rgba(0,0,0,0.1)',
    background: 'rgba(255, 255, 255, 0.1)',
  },
  borderRadius: 10,
  justifyContent: 'center',
}));

const Category = styled('div')(({ theme }) => ({
  background: alpha(theme.palette.primary.main, 0.2),
  width: 'fit-content',
  padding: theme.spacing(0, 1),
  borderRadius: theme.shape.borderRadius,
}));

const TrainingCard: React.FC<IProps<IArticle>> = ({ data }) => {
  const router = useRouter();
  const handleClick = (href: string) => {
    router.push(href);
  };
  return (
    <Item variant="outlined">
      <CardActionArea
        onClick={() => handleClick(`/our-trainings/${data.slug}`)}
      >
        <Box sx={{ position: 'relative', height: 220 }}>
          <Image
            alt={data.media.alternativeText}
            src={`${API}${data.media.url}`}
            layout="fill"
            objectFit="cover"
            quality={100}
          />
        </Box>
        <CardContent>
          <Link href="/tag" passHref>
            <Typography
              gutterBottom
              variant="h6"
              component="a"
              color="secondary"
            >
              {data?.category?.name}
            </Typography>
          </Link>
          <Typography
            gutterBottom
            variant="h3"
            noWrap
            component="h2"
            sx={{ my: 2 }}
          >
            {data?.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {data?.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Item>
  );
};

export default TrainingCard;
